import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/internet-explorer': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M483 159.7c25.2 45.4 33.3 97.6 26.9 141.2h-328.8c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-0.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145 35.1-63.7 81.4-124.9 135.7-173.2-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9zM64.6 346.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.4-82.6-72.2-100.3-123.3zM180.5 238h208c-2-55.2-50.6-94.9-104-94.9-53.7 0-102 39.7-104 94.9zM365.1 50.4c46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.9-53.7-54.3-53.7-24 0-51.1 11.7-72.6 22z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/internet-explorer.js
// module id = 888
// module chunks = 0